// this component will be the standard layout used across pages
import React, { useState, useEffect } from "react";
import Head from "./head";
import Header from "./header";
import Footer from "./footer";
import Alert from "./alert";
// import langBM from "../languages/bm"
// import langEN from "../languages/en"

import moment from "moment";

const Layout = ({ pageTitle, children, lang }) => {
    const [showIsmAlert, setShowIsmAlert] = useState(false);
    const [showJpjAlert, setShowJpjAlert] = useState(false);
    const [showJpjType, setShowJpjType] = useState(false);

    useEffect(() => {
        const now = moment();

        const testStart = moment("2025-01-23 17:00", "YYYY-MM-DD HH:mm");
        const testEnd = moment("2025-01-23 17:40", "YYYY-MM-DD HH:mm");

        const ismStart = moment("2025-01-23 10:00", "YYYY-MM-DD HH:mm");
        const ismEnd = moment("2025-01-24 01:00", "YYYY-MM-DD HH:mm");

        const jpjStart = moment("2025-02-28 22:00", "YYYY-MM-DD HH:mm");
        const jpjEnd = moment("2025-03-01 06:00", "YYYY-MM-DD HH:mm");

        const jpjStart2 = moment("2025-02-11 22:00", "YYYY-MM-DD HH:mm");
        const jpjEnd2 = moment("2025-02-12 05:00", "YYYY-MM-DD HH:mm");

        const jpjStart3 = moment("2025-02-19 22:00", "YYYY-MM-DD HH:mm");
        const jpjEnd3 = moment("2025-02-20 05:00", "YYYY-MM-DD HH:mm");

        if (now.isBetween(testStart, testEnd) || now.isBetween(ismStart, ismEnd)) {
            setShowIsmAlert(true);
        } else if (now.isBetween(jpjStart, jpjEnd)) {
            setShowJpjAlert(true);
            setShowJpjType(1);
        } else if (now.isBetween(jpjStart2, jpjEnd2)) {
            setShowJpjAlert(true);
            setShowJpjType(2);
        } else if (now.isBetween(jpjStart3, jpjEnd3)) {
            setShowJpjAlert(true);
            setShowJpjType(3);
        }
    }, []);

    return (
        <>
            <Head pageTitle={pageTitle} lang={lang} />
            {/* {<!-- Google Tag Manager (noscript) -->} */}
            <noscript>
                <iframe
                    src="https://www.googletagmanager.com/ns.html?id=GTM-PM577QT"
                    height="0"
                    width="0"
                    style={{
                        display: "none",
                        visibility: "hidden",
                    }}
                ></iframe>
            </noscript>
            <Header lang={lang} />
            {/* children is a standard naming for everything you place inside the component, so we put it below as we want the content to be in the middle */}
            <div className="">{children}</div>
            <Footer lang={lang} />
            {(showIsmAlert || showJpjAlert) && (
                <Alert
                    lang={lang}
                    showIsmAlert={showIsmAlert}
                    showJpjAlert={showJpjAlert}
                    showJpjType={showJpjType}
                />
            )}
        </>
    );
};

export default Layout;
